<template>
  <section class="mini-kasko-order__header">
    <div>
      <h1 class="mini-kasko-order__title">{{ pageTitle }}</h1>
      <p v-if="pageSubtitle" class="mini-kasko-order__subtitle">{{ pageSubtitle }}</p>
    </div>
    <div class="mini-kasko-order__meta">
      <button
        v-if="hasEarnings"
        type="button"
        class="mini-kasko-order__earnings-toggle"
        :class="{ 'mini-kasko-order__earnings-toggle--active': showEarnings }"
        @click="showEarnings = !showEarnings"
      >
        <span class="mini-kasko-order__earnings-toggle-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 5C6.72 5 2.42 8.11 1 12c1.42 3.89 5.72 7 11 7s9.58-3.11 11-7c-1.42-3.89-5.72-7-11-7Zm0 11.5A4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 0 1 0 9Zm0-2.5A2 2 0 1 0 12 10a2 2 0 0 0 0 4Z"
              fill="currentColor"
            />
          </svg>
        </span>
        Переглянути заробіток
      </button>
      <div class="mini-kasko-order__meta-item mini-kasko-order__meta-item--status">
        <span class="mini-kasko-order__meta-label">Статус</span>
        <span class="mini-kasko-order__status" :class="statusClass">
          {{ statusLabel }}
        </span>
      </div>
      <div class="mini-kasko-order__meta-item">
        <span class="mini-kasko-order__meta-label">Вартість продукту</span>
        <span class="mini-kasko-order__meta-value">{{ formattedPrice }}</span>
      </div>
      <div v-if="showEarnings && hasEarnings" class="mini-kasko-order__meta-item mini-kasko-order__meta-item--earnings">
        <span class="mini-kasko-order__meta-label">Заробіток</span>
        <span class="mini-kasko-order__meta-value">
          {{ formattedEarnings }}
          <span v-if="earningsPercent !== null" class="mini-kasko-order__meta-value-hint">({{ earningsPercent }}%)</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MiniKaskoOrderHeader',
  props: {
    pageTitle: String,
    pageSubtitle: String,
    statusLabel: String,
    statusClass: String,
    formattedPrice: String,
    hasEarnings: Boolean,
    // showEarnings: Boolean,
    formattedEarnings: String,
    earningsPercent: {
      type: Number,
      default: null,
    },
  },
  // emits: ['toggle-earnings'],
  data() {
    return {
      showEarnings: false,
    }
  }
};
</script>

<style lang="scss" scoped>
.mini-kasko-order {
  &__header {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    align-items: center;
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  &__subtitle {
    color: #52525b;
    font-size: 14px;
    line-height: 20px;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  &__meta-item {
    min-width: 120px;
    padding: 12px 14px;
    background: #f8fafc;
    border-radius: 8px;

    &--status {
      min-width: 156px;
    }

    &--earnings {
      background: #fff7ed;
      border: 1px solid #fed7aa;
    }
  }

  &__meta-label {
    display: block;
    color: #71717a;
    font-size: 12px;
    margin-bottom: 4px;
  }

  &__meta-value {
    font-size: 16px;
    font-weight: 600;
  }

  &__meta-value-hint {
    color: #9a3412;
    font-size: 13px;
    font-weight: 500;
  }

  &__earnings-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 48px;
    padding: 0 16px;
    border-radius: 8px;
    border: 0;
    background: #fff;
    color: #18181b;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
      background: #f8fafc;
    }

    &--active {
      background: #fff7ed;
      color: #9a3412;
    }
  }

  &__earnings-toggle-icon {
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 30px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;

    &--new {
      background: #f4f4f5;
      color: #3f3f46;
    }

    &--draft {
      background: #eff6ff;
      color: #1d4ed8;
    }

    &--warning {
      background: #fff7ed;
      color: #c2410c;
    }

    &--success {
      background: #f0fdf4;
      color: #15803d;
    }
  }

  @media (max-width: 960px) {
    &__header {
      display: flex;
      flex-direction: column;
    }

    &__meta {
      justify-content: flex-start;
    }
  }

  @media (max-width: 640px) {
    &__header {
      padding: 16px;
    }
  }
}
</style>
